/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Redeem_SubmitInputs */

const en_common_sign_redeem_submit = /** @type {(inputs: Common_Sign_Redeem_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const zh_common_sign_redeem_submit = /** @type {(inputs: Common_Sign_Redeem_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Common_Sign_Redeem_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_redeem_submit = /** @type {((inputs?: Common_Sign_Redeem_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Redeem_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_redeem_submit(inputs)
	return zh_common_sign_redeem_submit(inputs)
});
export { common_sign_redeem_submit as "common.sign.redeem_submit" }